/* src/app/reports/order-report/order-report.component.css */
.filters-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 20px;
  row-gap: 10px;
  padding-bottom: 8px;
}
.filters-bar--date {
  padding-top: 4px;
}
.filter-field {
  flex: 0 1 190px;
  width: 190px;
}
.filter-field--range {
  flex: 0 1 280px;
  width: 280px;
}
.filter-field--narrow {
  flex: 0 1 110px;
  width: 110px;
}
.search-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 0 0 auto;
  height: 56px;
  padding: 0 20px;
  white-space: nowrap;
}
.search-button mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
}
.search-button:disabled {
  background-color: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.38) !important;
  cursor: not-allowed;
}
.clear-icon {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.4);
}
.clear-icon:hover {
  color: rgba(0, 0, 0, 0.7);
}
.order-number-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 8px;
  padding: 8px 12px;
  background: #fff4e0;
  border: 1px solid #f0c674;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.75);
  font-size: 13px;
}
.order-number-banner mat-icon {
  color: #b8860b;
  font-size: 20px;
  height: 20px;
  width: 20px;
  flex-shrink: 0;
}
/*# sourceMappingURL=order-report.component.css.map */
